import config from '@/config'
import axios from 'axios'

export default {
  functionsUrl: config.midServer,
  instance: config.firebase.authDomain,
  /**
   * Get user by email address
   * @param {string} email - user email
   */
  getUserByEmail (email) {
    return new Promise((resolve) => {
      let xhr = new XMLHttpRequest()
      let url = `${this.functionsUrl}/getUserByEmail?email=${email}`

      xhr.open('GET', url, true)

      xhr.onload = function () {
        resolve(JSON.parse(this.responseText))
      }

      xhr.send()
    })
  },
  getUserList () {
    return new Promise((resolve) => {
      let xhr = new XMLHttpRequest()
      let url = `${this.functionsUrl}/getUserList`

      xhr.open('GET', url, true)

      xhr.onload = function () {
        resolve(JSON.parse(this.responseText))
      }

      xhr.send()
    })
  },
  create (data) {
    data.instance = this.instance
    data.email = encodeURIComponent(data.email)

    return axios.post(
      `${this.functionsUrl}/createUser`,
      JSON.stringify(data)
    )
  },
  resetUserPass (data) {
    return axios.post(
      `${this.functionsUrl}/resetUserPass`,
      JSON.stringify(data)
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/user.js